import * as React from 'react';
import ReferenceMediaTextSection from './reference-media-text-section';

export default function ReferenceIntroSection({ blok }) {
  return (
    <ReferenceMediaTextSection
      blok={blok}
      sectionClassName="pt-8 lg:pt-16"
      titleTag="h1"
      mobileTitleFirst
      imageSizes="(max-width: 1024px) 100vw, 42vw"
      desktopGridClassRight="lg:grid-cols-[3fr_2fr]"
      desktopGridClassLeft="lg:grid-cols-[2fr_3fr]"
    />
  );
}